import { ChatDto, ChatParticipantDto } from '@careapp-group/ng-sdk-v2-new';
import { createSelector } from '@ngrx/store';
import { DataListState, INITIAL_DATA_LIST_STATE } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';
import { Chats } from './chats.actions';

export interface ChatsState extends DataListState<ChatDto> {
  tokens: { [key: string]: string };
}

export class ChatsReducer extends ReducerStateFactory<ChatDto> {
  initialState: ChatsState = {
    ...INITIAL_DATA_LIST_STATE,
    tokens: {},
  };

  protected allReducer(state: ChatsState, action): ChatsState {
    switch (action.type) {
      case Chats.REQUEST_JOIN:
        return {
          ...state,
          error: null,
          loadingEntities: {
            ...state.loadingEntities,
            [action.payload]: true,
          },
        };
      case Chats.RESPONSE_SUCCESS_JOIN: {
        const joined: ChatParticipantDto = action.payload;
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [joined.chatId]: false,
          },
          tokens: {
            ...state.tokens,
            [joined.chatId]: joined.externalToken,
          },
        };
      }
      case Chats.RESPONSE_FAIL_JOIN: {
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.id]: false,
          },
          error: action.error,
        };
      }
      case Chats.REQUEST_END:
        return {
          ...state,
          error: null,
          loadingEntities: {
            ...state.loadingEntities,
            [action.chatId]: true,
          },
        };
      case Chats.RESPONSE_SUCCESS_END: {
        const joined: ChatDto = action.payload;
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [joined.id]: false,
          },
          tokens: {
            ...state.tokens,
            [joined.id]: null,
          },
        };
      }
      case Chats.RESPONSE_FAIL_END: {
        return {
          ...state,
          loadingEntities: {
            ...state.loadingEntities,
            [action.id]: false,
          },
          error: action.error,
        };
      }
    }

    return super.allReducer(state, action) as ChatsState;
  }
}

export const state = new ChatsReducer(Chats);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const createSelectors = (rootReducer) => {
  const getChatTokenMap = createSelector(rootReducer, (state: ChatsState) => state.tokens);
  const getChatError = createSelector(rootReducer, (state: ChatsState) => state.error);
  const selectedId = createSelector(rootReducer, (state: ChatsState) => state.selectedId);
  const getSelectedChatToken = createSelector(
    getChatTokenMap,
    selectedId,
    (tokenMap, selectedId) => tokenMap[selectedId]
  );

  return {
    getChatError,
    getChatTokenMap,
    getSelectedChatToken,
  };
};
